module.exports = __webpack_public_path__ + "assets/sign.c8a46b58.svg";